










import './KisweTimer.scss'
import { computed, defineComponent, toRef } from '@vue/composition-api'
import KisweDate from '@/modules/common/classes/KisweDate'
import { useThemes } from '../../compositions'
import { KisweTheme } from '../../types'

export default defineComponent({
  name: 'KisweTimer',
  props: {
    unix: {
      type: Number,
      required: true
    },
    ...useThemes({ theme: KisweTheme.Info }).props
  },
  setup (props) {
    const unix = toRef(props, 'unix')
    const time = computed(() => {
      if (unix.value >= 3600) return KisweDate.formatOffset(unix.value, 'HH:mm:ss')
      else return KisweDate.formatOffset(unix.value, 'mm:ss')
    })
    return {
      time
    }
  }
})
